import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/ibm-aiops-training/ibm-aiops-training/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Accordion = makeShortcode("Accordion");
const AccordionItem = makeShortcode("AccordionItem");
const InlineNotification = makeShortcode("InlineNotification");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3>{`Creating the CP4AIOPS Instance`}</h3>
    <p>{`In this chapter you will install CP4AIOPS`}</p>
    <h2>{`🚀 TASK: Create the CP4AIOPS Instance`}</h2>
    <a href="https://www.ibm.com/docs/en/cloud-paks/cloud-pak-aiops/4.6.0?topic=aiops-starter-installation" target="_blank">🌏 Documentation for the Task: Online starter installation of CP4AIOPS</a>
    <img {...{
      "src": "./../images/54_aimanager_story.png",
      "alt": "image"
    }}></img>
    <p>{`Now it’s time to create the CP4AIOPS Instance by creating the `}<inlineCode parentName="p">{`Installation`}</inlineCode>{` resource.`}</p>
    <p>{`To do this create an instance of the CP4AIOPS `}<inlineCode parentName="p">{`Installation`}</inlineCode>{` Custom Resource called `}<inlineCode parentName="p">{`ibm-cp-watson-aiops`}</inlineCode>{` with `}<inlineCode parentName="p">{`size: small`}</inlineCode>{` as we’ll use this only for the training and not for production (see note below).`}</p>
    <Accordion mdxType="Accordion">
      <AccordionItem title="💡 Solution (For IPI and UPI Techzone Clusters use this)?" mdxType="AccordionItem">
        <ol>
          <li parentName="ol">
            <p parentName="li">{`Run the following command to create an instance of CP4AIOPS.`}</p>
            <pre parentName="li"><code parentName="pre" {...{
                "className": "language-yaml"
              }}>{`cat << EOF | oc apply -f -
apiVersion: orchestrator.aiops.ibm.com/v1alpha1
kind: Installation
metadata:
  name: ibm-cp-aiops
  namespace: ibm-aiops 
spec:
  enableConnectionModule: true
  imagePullSecret: ibm-entitlement-key
  license:
    accept: true
  pakModules:
  - name: aiopsFoundation
    enabled: true
  - name: applicationManager
    enabled: true
  - name: aiManager
    enabled: true
  - name: connection
    enabled: true
  size: small
  storageClass: ocs-storagecluster-cephfs
  storageClassLargeBlock: ocs-storagecluster-ceph-rbd
EOF
`}</code></pre>
          </li>
        </ol>
        <InlineNotification kind="info" mdxType="InlineNotification">
          <p>{`This creates the `}<inlineCode parentName="p">{`Installation`}</inlineCode>{` instance that the Operator will pick up and start the installation. `}</p>
        </InlineNotification>
      </AccordionItem>
    </Accordion>
    <Accordion mdxType="Accordion">
      <AccordionItem title="💡 Solution (For Classic ROKS Clusters use this)?" mdxType="AccordionItem">
        <ol>
          <li parentName="ol">
            <p parentName="li">{`Run the following command to create an instance of CP4AIOPS.`}</p>
            <pre parentName="li"><code parentName="pre" {...{
                "className": "language-yaml"
              }}>{`cat << EOF | oc apply -f -
apiVersion: orchestrator.aiops.ibm.com/v1alpha1
kind: Installation
metadata:
  name: ibm-cp-watson-aiops
  namespace: ibm-aiops
spec:
  enableConnectionModule: true
  imagePullSecret: ibm-entitlement-key
  license:
    accept: true
  pakModules:
  - name: aiopsFoundation
    enabled: true
  - name: applicationManager
    enabled: true
  - name: aiManager
    enabled: true
  - name: connection
    enabled: true
  size: small
  storageClass: ibmc-file-gold-gid
  storageClassLargeBlock: ibmc-block-gold
EOF
`}</code></pre>
          </li>
        </ol>
        <InlineNotification kind="info" mdxType="InlineNotification">
          <p>{`This creates the `}<inlineCode parentName="p">{`Installation`}</inlineCode>{` instance that the Operator will pick up and start the installation. `}</p>
        </InlineNotification>
      </AccordionItem>
    </Accordion>
    <InlineNotification kind="error" mdxType="InlineNotification">
      <p><strong parentName="p">{`Important - This takes up to 90 minutes`}</strong></p>
      <p>{`This takes some time depending on what region of ROKS you have chosen.`}</p>
      <p>{`Wait for the installation to complete before continuing. `}</p>
      <p>{`The next step explains how to follow the installation progress.`}</p>
    </InlineNotification>
    <InlineNotification kind="info" mdxType="InlineNotification">
      <p><strong parentName="p">{`Note - This is only for non-production installations`}</strong></p>
      <p>{`If you want to install CP4AIOPS for production use please follow the documentation and make sure that you use `}<inlineCode parentName="p">{`size: large`}</inlineCode>{`, as well as a recommended storage provider.`}</p>
      <p>{`See here: `}<a href="https://www.ibm.com/docs/en/cloud-paks/cloud-pak-aiops/4.6.0?topic=installation-online-console" target="_blank">{`Online production installation of IBM CloudPak for AIOps CP4AIOPS`}</a>{` `}</p>
    </InlineNotification>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      